module.exports = __webpack_public_path__ + "static/media/guy.4ac25153.png";